export default {
  'Difficulty level': 'Nivel de dificultate',
  'Your bet': 'Pariu',
  'Start game': 'Joacă',
  'Take prize': 'Lua',
  'Try again': 'Încearcă din nou',
  Bet: 'Pariu',
  Profit: 'Profit',
};
